import React from "react";

const Heading = ({ heading = "" }) => {
    return <h1 className="standard-heading-22-600">{heading}</h1>;
};

export default Heading;
